import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Spin, Row, Col, Input, Button, Layout, Table, DatePicker, Select, message } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'

import {orderList, orderDelete, exportUrl,getGoodsName } from '_src/api/api'
import {getStatus} from './commo/common'
import './order.less'

const { Search } = Input

const { RangePicker } = DatePicker
const { Option } = Select

class Order extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: false,
      modelVisible: false,

      pageData: {
        total: 0, 
        current: 1, 
      },

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      list: [],
      goodsName:[],

      columns: [
        {
          title: <span>订单编号</span>,
          align: 'center',
          dataIndex: 'orderSn',
          key: 'id',
        },
        {
          title: <span>用户账号</span>,
          align: 'center',
        render:item => <div>{item.user.mobile}</div>
        },
        {
          title: <span>提交时间</span>,
          align: 'center',
          dataIndex: 'createAt',
          render: item => moment(item).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          title: <span>联系电话</span>,
          dataIndex: 'mobile',
          align: 'center',
        },
        {
          title: <span>收货人</span>,
          dataIndex: 'consignee',
          align: 'center',
        },
        {
          title: <span>收货地址</span>,
          dataIndex: 'address',
          align: 'center',
        },
        {
          title: <span>订单金额</span>,
          dataIndex: 'orderPrice',
          align: 'center',
          render: item => (item / 100).toFixed(2)
        },
        {
          title: <span>支付方式</span>,
          align: 'center',
          render: item => '微信支付'
        },
        {
          title: <span>订单来源</span>,
          dataIndex: 'orderSource',
          align: 'center',
          render: item => 'APP'
        },
        {
          title: <span>订单状态</span>,
          dataIndex: 'status',
          align: 'center',
          render: status => getStatus(status)
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <Link to={{ pathname: '/order/detail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
        },
      ]
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.getGoodsName()
    this.loadList(params)
  }
  getButton (item) { 
    switch (item.status) {
    // 未支付
    case 101:
      return (
        <div>
          <Link to={{ pathname: '/order/detail?id=' + item.id}} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
          <Button icon="close" type="danger" onClick={() => { this.look(item.id) }}>关闭订单</Button>
        </div>
      )
      // 已取消
    case 102:
    case 103:
      return (
        <div>
          <Link to={{ pathname: '/order/detail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
          <Button icon="delete" type="danger" rel="noopener noreferrer" onClick={() => { this.delete(item.id) }}>删除订单</Button>
        </div>
      )
      // 待发货
    case 201:
      return (
        <div>
          <Link to={{ pathname: '/order/detail?id=' + item.id}} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
          <Button icon="file-protect" type="primary" onClick={() => { this.look(item.id) }}> 订单发货</Button>
        </div>
      )
      // 已完成
    case 401:
      return (
        <div>
          <Link to={{ pathname: '/order/detail?id=' + item.id}} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
          <Button icon="build" onClick={() => { this.look(item.id) }}>订单跟踪</Button>
        </div>
      )
      // 已发货
    case 301:
    case 402:
      return (
        <div>
          <Link to={{ pathname: '/order/detail?id=' + item.id}} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
          <Button icon="build" onClick={() => { this.look(item.id) }}>订单跟踪</Button>
        </div>
      )
    default: 
      return <Link to={{ pathname: '/order/detail?id=' + item.id}} target="_blank" style={{marginRight: 10}}><Button icon="eye">详情</Button></Link>
    }
  }
  getGoodsName = () =>{
    getGoodsName().then(res =>{
      this.setState({
        goodsName:res.data
      })
    }).catch(err => {
      this.setState({
        goodsName:[]
      })
    })
  }
  loadList = (params) => {
    this.setState({ isLoading: true })
    orderList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })  
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }
  // 删除订单
  delete = (id) => {
    orderDelete({id})
      .then(res => {
        
      })
  }
  // 通用切换事件
  commonChange = (e, key) => {
    const {params} = this.state
    params.pageNum = 0
    if (e) {
      params[key] = e
    } else {
      delete params[key]
    }
    this.setState({params}, ()=>{
      console.log(this.state.params)
    })
    this.loadList(params)
  }

  // 时间切换
  timerChange = (e) => {
    const {params} = this.state
    params.pageNum = 0
    if (e.length) {
      params.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      params.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    } else {
      delete params.createStart
      delete params.createEnd
    }
    this.setState({params})
    this.loadList(params)
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  //导出
  exportExcel = () => {
    const userinfo = JSON.parse(localStorage.getItem('access_info'))
    const {params,list} = this.state
    params.token = userinfo.token    
    delete params.pageNum
    delete params.pageSize
    let linkUrl = exportUrl
    if(!!list.length){
      Object.keys(params).map(key => {
        linkUrl = this.addURLParam(linkUrl,key,params[key])
      })
      console.log(linkUrl)
      window.location.href = linkUrl
    }else{
      message.error('没有需要导出的数据', 1.5)
    }
  }

  addURLParam = (url,key,value) => {
    url +=(url.indexOf("?")==-1?"?":"&")
    url +=key+'='+encodeURIComponent(value)
    return url
  }

  render () {
    const {isLoading, columns, list, pageData,goodsName} = this.state
    return (
      <Layout className='order-list-page'>
        { this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-header'>
          <Row>
            <Col xl={{ span: 4}} md={{ span: 8 }} style={{ width: 200, marginBottom: 20 }} className="flex-h-a">
              <span >订单状态：</span>
              <Select defaultValue='全部订单' style={{ width: 120 }} onChange={(e)=>this.commonChange(e, 'statusMultiple')}>
                <Option value="">全部订单</Option>
                <Option value={'11'}>待付款</Option>
                <Option value={'21'}>待发货</Option>
                <Option value={'31'}>已发货</Option>
                <Option value={'41,42'}>已收货</Option>
                <Option value={'61,62'}>已完成</Option>
                <Option value={'12,13'}>已取消</Option>
                <Option value={'63'}>退款失败</Option>
              </Select>
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 320, marginBottom: 20 }} className="flex-h-a">
              <span >提交时间：</span>
              <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
            </Col>
            <Col lg={{ span: 6 }} style={{ width: 300, marginBottom: 20 }}className="flex-h-a">
              <span >编号搜索：</span>
              <Search style={{ width: 200 }} placeholder="订单编号" onSearch={(e)=>this.commonChange(e, 'orderSn')} enterButton />
            </Col>
            <Col lg={{ span: 6 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >收货人姓名：</span>
              <Search style={{ width: 200 }} placeholder="收货人姓名" onSearch={(e)=>this.commonChange(e, 'consignee')} enterButton />
            </Col>
            <Col lg={{ span: 6 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >手机号码：</span>
              <Search style={{ width: 200 }} placeholder="手机号码" onSearch={(e)=>this.commonChange(e, 'mobile')} enterButton />
            </Col>
            <Col lg={{ span: 6 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >用户账号：</span>
              <Search style={{ width: 200 }} placeholder="用户账号" onSearch={(e)=>this.commonChange(e, 'account')} enterButton />
            </Col>
            <Col lg={{span:4}} style={{width:100}}>
              <Button type="primary" icon="download" onClick={this.exportExcel}>导出</Button>
            </Col>
            <Col xl={{ span: 6}} md={{ span: 8 }} style={{ marginBottom: 20 }} className="flex-h-a">
              <span >商品名称：</span>
              <Select defaultValue='全部商品' style={{ width: 200 }} onChange={(e)=>this.commonChange(e, 'goodsName')}>
                <Option value="">全部商品</Option>
                {
                  goodsName.map((item,index) => {
                    return <Option value={item} key={index}>{item}</Option>
                  })
                }
              </Select>
            </Col>
          </Row>
        </div>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
      </Layout>
    )
  }
}

export default connect(res => ({...res}))(Order)